import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IExamPaper } from "./types";

export const getExamPaper = async (id: string) => {
  const response = await apiGet<IExamPaper>(`/exam_papers/${id}`);
  return response.data;
};

export const useQueryGetExamPaper = (
  id: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: QueryKeys.examPaper.detail(id),
    queryFn: () => getExamPaper(id),
    enabled: !!id && options?.enabled !== false,
  });
};
